// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { PanelBody, BaseControl } from "@wordpress/components";
import { RichText, InspectorControls } from "@wordpress/block-editor";
import PostSelector from "../../components/Gutenberg/PostSelector";

// Internal dependencies
import LandmarkCases from "./LandmarkCases";

// Block attributes (custom props)
const attributes = {
    headline: {
        type: 'text',
        default: "Landmark cases"
    },
    description: {
        type: 'text',
        default: "See the impact we have together. With your support we can stand up for precious places, species and people."
    },
    carousels: {
        type: 'array',
        default: [{
            headline: 'Protect Country and culture',
            publications: []
        }, {
            headline: 'Protect Country and culture',
            publications: []
        }, {
            headline: 'Protect Country and culture',
            publications: []
        }]
    }
}

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, ...props }) => {
    const { headline, description, carousels } = props.attributes;

    const handleChange = (item, index) => ({ headline, publications }) => {
        const newCarousels = [...carousels];
        newCarousels[index] = {
            ...item,
            headline: headline || item.headline,
            publications: publications || item.publications,
        }
        setAttributes({ carousels: newCarousels });
    }

    return (
        <Fragment>
            <InspectorControls>
                <PanelBody title={__("")}>
                    {carousels.map((item, index) => {
                        const onChange = handleChange(item, index)
                        return (<BaseControl
                            key={`post-selector-${index}`}
                            label={`Select "${item.headline}" items`}
                            help={`Select "${item.headline}" items`}
                        >
                            <PostSelector
                                value={item.publications}
                                onChange={(publications) => onChange({ publications: publications || [] })}
                                isMulti
                            />
                        </BaseControl>)
                    })}
                </PanelBody>
            </InspectorControls>
            <LandmarkCases
                headline={<RichText
                    value={headline}
                    multiline={false}
                    onChange={(headline) => setAttributes({ headline })}
                    placeholder={__('Headline', 'hero')}
                    allowedFormats={[]}
                    keepPlaceholderOnFocus={true}
                />}
                description={<RichText
                    value={description}
                    multiline={false}
                    onChange={(description) => setAttributes({ description })}
                    placeholder={__('Description', 'hero')}
                    allowedFormats={[]}
                    keepPlaceholderOnFocus={true}
                />}
                carousels={carousels.map((item, index) => {
                    const onChange = handleChange(item, index)

                    return ({
                        ...item,
                        headline: <RichText
                            value={item.headline}
                            multiline={false}
                            onChange={(headline) => onChange({ headline })}
                            placeholder={__('Summary', 'hero')}
                            allowedFormats={[]}
                            keepPlaceholderOnFocus={true}
                        />,
                    })
                })}
            />
        </Fragment>
    );
}

// Save function (responsible for static HTML saved in database)
const save = ({ attributes }) => {
    const { headline, description, carousels } = attributes;

    return (
        <div className="gutenberg-landmark-cases" data-mt-attributes={encodeURIComponent(JSON.stringify(attributes))}>
            <LandmarkCases
                headline={<RichText.Content
                    value={headline}
                />}
                description={<RichText.Content
                    value={description}
                />}
                carousel={carousels}
                isSave
            />
        </div>
    );
}

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-landmark-cases", {

    /**
     * This is the display title for your block, which can be translated with `i18n` functions.
     * The block inserter will show this name.
     */
    title: __("Landmark Cases", "gutenberg-landmark-cases"),

    /**
     * An icon property should be specified to make it easier to identify a block.
     * These can be any of WordPress’ Dashicons, or a custom svg element.
     */
    icon: "align-wide",

    /**
     * Blocks are grouped into categories to help users browse and discover them.
     * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
     */
    category: "widgets",

    /**
     * Optional block extended support features.
     */
    // supports: {
    //     // Removes support for an HTML mode.
    //     html: false
    // },
    attributes,

    /**
     * The edit function describes the structure of your block in the context of the editor.
     * This represents what the editor will render when the block is used.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
     *
     * @param {Object} [props] Properties passed from the editor.
     *
     * @return {WPElement} Element to render.
     */
    edit,

    /**
     * The save function defines the way in which the different attributes should be combined
     * into the final markup, which is then serialized by the block editor into `post_content`.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
     *
     * @return {WPElement} Element to render.
     */
    save
});
